module.exports = __webpack_public_path__ + "static/media/image.ef76534b.jpg";